import React from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import { transformTranslateFromValues, dateTimeToserver } from "lib/helpers";
import Modal from "components/Modal";
import { TextArea } from "components/form";
import { GalleryField } from "components/form";
import SearchSelect from "utils/SearchSelect";
import extractValues from "utils/extractValues";
import MetaDataComponent from "utils/MetaDataComponent";
// components

const transferTypes = [
  { label: "دایمی", value: "permanent" }, // Grass: چمن طبیعی
  { label: "قرضی", value: "loan" }, // Artificial: چمن مصنوعی
];

export default function Add(props) {
  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{}}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            if (values.birthday)
              values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");

            const result = extractValues(values, [
              "player",
              "fromTeam",
              "toTeam",
            ]);

            await props.submit(result);
            resetForm();
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values, setFieldValue }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="نام مدیر برنامه بازیکن"
                    label="نام مدیر برنامه بازیکن :"
                    name="translations.fa.agentName"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام مدیر برنامه بازیکن(en)"
                    label="نام مدیر برنامه بازیکن (en):"
                    name="translations.en.agentName"
                    component={TextField}
                  />

                  <Field
                    placeholder=" (مثلاً ارتقاء، پایان قرارداد)"
                    label=" (مثلاً ارتقاء، پایان قرارداد) :"
                    name="translations.fa.reason"
                    component={TextField}
                  />
                  <Field
                    placeholder=" (مثلاً ارتقاء، پایان قرارداد)(en)"
                    label=" (مثلاً ارتقاء، پایان قرارداد)(en) :"
                    name="translations.en.reason"
                    component={TextField}
                  />

                  <Field
                    placeholder="جزئیات قرارداد"
                    label="جزئیات قرارداد :"
                    name="translations.fa.contractDetails"
                    component={TextArea}
                  />
                  <Field
                    placeholder="جزئیات قرارداد(en)"
                    label="جزئیات قرارداد(en) :"
                    name="translations.en.contractDetails"
                    component={TextArea}
                  />

                  <div className="intro-y">
                    <span>مبلغ انتقال :</span>
                    <Field
                      label=" مبلغ انتقال: "
                      name="transferFee"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label=" نوع انتقال :"
                      name="transferType"
                      component={Select}
                      options={transferTypes}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                  {/* 
                  <Field
                    label="بازیکن  :"
                    name="player"
                    component={Select}
                    options={[]}
                    className="w-full px-3 py-2 border rounded"
                  /> */}

                  <div>
                    <Field
                      label="بازیکن:"
                      name="player"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="player"
                      showFields="translations.name,translations.lastName"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <Field
                    label="تیم مبدا  :"
                    name="fromTeam"
                    component={SearchSelect}
                    searchFields="translations.name"
                    collectionName="team"
                    showFields="translations.name"
                    className="w-full px-3 py-2 border rounded"
                  />

                  <Field
                    label="تیم مقصد  :"
                    name="toTeam"
                    component={SearchSelect}
                    searchFields="translations.name"
                    collectionName="team"
                    showFields="translations.name"
                    className="w-full px-3 py-2 border rounded"
                  />

                  <div className="user-datepicker">
                    <Field
                      label="تاریخ انتقال :"
                      name="transferDate"
                      component={PersianDataPicker}
                    />
                  </div>

                  <div className="user-datepicker">
                    <Field
                      label="تاریخ شروع قرارداد با تیم مقصد :"
                      name="contractStartDate"
                      component={PersianDataPicker}
                    />
                  </div>

                  <div className="user-datepicker">
                    <Field
                      label="تاریخ پایان قرارداد با تیم مقصد :"
                      name="contractEndDate"
                      component={PersianDataPicker}
                    />
                  </div>

                  <MetaDataComponent
                    values={values}
                    setFieldValue={setFieldValue}
                    type="Transfer"
                  />
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
